'use client'

import { useState, useEffect } from 'react'

interface UseNewsletterPopupProps {
  delaySeconds?: number
  scrollThreshold?: number
  maxFrequencyHours?: number
}

export function useNewsletterPopup({
  delaySeconds = 8,
  scrollThreshold = 25,
  maxFrequencyHours = 24,
}: UseNewsletterPopupProps = {}) {
  const [isVisible, setIsVisible] = useState(false)
  const [hasShown, setHasShown] = useState(false)

  useEffect(() => {
    // Verificar si ya se mostró recientemente
    const lastShown = localStorage.getItem('newsletterPopupLastShown')
    const isSubscribed = localStorage.getItem('newsletterSubscribed')

    if (lastShown || isSubscribed) {
      const lastShownDate = new Date(lastShown || '0')
      const hoursSinceLastShown =
        (Date.now() - lastShownDate.getTime()) / (1000 * 60 * 60)

      if (hoursSinceLastShown < maxFrequencyHours) {
        return // No mostrar si se mostró recientemente
      }
    }

    // Timer para mostrar después del delay
    const timer = setTimeout(() => {
      if (!hasShown) {
        setIsVisible(true)
        setHasShown(true)
        localStorage.setItem(
          'newsletterPopupLastShown',
          new Date().toISOString()
        )
      }
    }, delaySeconds * 1000)

    // Detectar scroll del 25%
    const handleScroll = () => {
      if (hasShown) return

      const scrollPercent =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100

      if (scrollPercent >= scrollThreshold) {
        setIsVisible(true)
        setHasShown(true)
        localStorage.setItem(
          'newsletterPopupLastShown',
          new Date().toISOString()
        )
        clearTimeout(timer)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      clearTimeout(timer)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [delaySeconds, scrollThreshold, maxFrequencyHours, hasShown])

  const closePopup = () => {
    setIsVisible(false)
  }

  return {
    isVisible,
    closePopup,
  }
}
